import { emitRest, socketEmit, socketOff } from 'lib/clients/socket';

export default (response, sessionToken, sessionClientId) => {
  if (response?.ok) {
    socketEmit('user-auth', { token: sessionToken, sessionClientId });
    emitRest();
  }

  socketOff('user-init');
};
